import React, { useState } from 'react'
import { toast } from 'react-toastify'
import constant from '../../constant'
import { hasPermission } from '../../utils/hasPermission'
import { v3_delete_production_form } from '../../actions/v3/productionForm'
import { v3_delete_site_management_form } from '../../actions/v3/siteManagement'

/**
 * Delete action for a submitted form. Renders as an <li> so it drops into the
 * existing `ul.list-inline` action cell of any Submitted form list, next to
 * <ReportActions />.
 *
 * The delete is a soft delete server-side (IS_DELETED = 1); there is no restore
 * screen, so the confirm is the last chance the user gets.
 */
const DeleteFormAction = ({ item, module = 'production', formCode, formName, formId: formIdProp, onDeleted }) => {
    const [deleting, setDeleting] = useState(false)

    const isSiteManagement = module === 'siteManagement'
    const permissionId = isSiteManagement
        ? constant.actionPermission.siteManagementDeleteForm
        : constant.actionPermission.productionDeleteForm

    // Same id fallback as ReportActions: the lists select submission.ID, some alias
    // it FORM_ID, and the consolidated Reports list passes formId explicitly.
    const formId = formIdProp ?? item?.ID ?? item?.FORM_ID

    if (!formId || !hasPermission(permissionId)) return null

    const handleDelete = (e) => {
        e.preventDefault()
        if (deleting) return

        const label = formName ? `this ${formName}` : 'this form'
        if (!window.confirm(`Delete ${label}? It will be removed from the lists and reports.`)) return

        setDeleting(true)
        const request = isSiteManagement
            ? v3_delete_site_management_form(formCode, formId)
            : v3_delete_production_form(formCode, formId)

        request.then((res) => {
            if (res.status) {
                toast.success(res.result?.message || 'Form deleted successfully.')
                if (onDeleted) onDeleted(formId)
            } else {
                toast.error(res.error?.message || res.error || 'Failed to delete form.')
            }
        }).catch(() => {
            toast.error('Failed to delete form.')
        }).finally(() => setDeleting(false))
    }

    return (
        <li className="list-inline-item px-0">
            <a href="#" title="Delete Form" onClick={handleDelete}>
                <i className={deleting ? 'bx bx-loader bx-spin' : 'bx bx-trash text-danger'} />
            </a>
        </li>
    )
}

export default DeleteFormAction
